<script setup lang="ts">
import { defineQuery } from "groq";

const MUSIC_INDEX_QUERY = defineQuery(
  `*[_type == "music"]{..., artist->{name, slug}}`
);
const { data: music } = await useSanityQuery(MUSIC_INDEX_QUERY);
</script>

<template>
  <UContainer>
    <h1
      class="font-serif text-lg tracking-wide dark:text-gray-200 text-gray-600 mt-6"
    >
      Music
    </h1>
    <section class="mt-2">
      <NuxtLink
        v-for="song in music"
        :key="song._id"
        :href="`/music/${song.slug?.current}`"
      >
        <h3 class="text-2xl font-semibold font-serif">{{ song.title }}</h3>
        <p v-if="song.artist" class="text-gray-500">
          by {{ song.artist.name }}
        </p>
      </NuxtLink>
    </section>
  </UContainer>
</template>
